import { analyticsConfig } from './config';

interface GoogleAnalyticsWindow extends Window {
  dataLayer?: unknown[];
  gtag?: (...args: unknown[]) => void;
}

const GA_SCRIPT_ID = 'landing-page-ga-loader';
const GA_INIT_SCRIPT_ID = 'landing-page-ga-init';

function getGaWindow() {
  return window as GoogleAnalyticsWindow;
}

function appendScript(id: string, attributes: Record<string, string | boolean>) {
  if (document.getElementById(id)) {
    return;
  }

  const head = document.head;
  const script = document.createElement('script');

  script.id = id;

  Object.entries(attributes).forEach(([key, value]) => {
    if (typeof value === 'boolean') {
      if (value) {
        script.setAttribute(key, '');
      }
      return;
    }

    script.setAttribute(key, value);
  });

  head.appendChild(script);
}

export function setupGoogleAnalytics() {
  const { enabled, measurementId } = analyticsConfig.googleAnalytics;

  if (!enabled || !measurementId || typeof document === 'undefined') {
    return;
  }

  appendScript(GA_SCRIPT_ID, {
    async: true,
    src: `https://www.googletagmanager.com/gtag/js?id=${measurementId}`,
  });

  const gaWindow = getGaWindow();

  if (!gaWindow.dataLayer) {
    gaWindow.dataLayer = [];
  }

  if (!gaWindow.gtag) {
    gaWindow.gtag = (...args: unknown[]) => {
      gaWindow.dataLayer?.push(args);
    };
  }

  if (!document.getElementById(GA_INIT_SCRIPT_ID)) {
    const initScript = document.createElement('script');

    initScript.id = GA_INIT_SCRIPT_ID;
    initScript.textContent = [
      'window.dataLayer = window.dataLayer || [];',
      'function gtag(){dataLayer.push(arguments);}',
      "gtag('js', new Date());",
      `gtag('config', '${measurementId}');`,
    ].join('\n');

    document.head.appendChild(initScript);
  }
}
